import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gax-page-footer-actions',
  templateUrl: './page-footer-actions.component.html',
  styleUrl: './page-footer-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageFooterActionsComponent {}
